const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function formatFCFA(value) {
  const n = Number(value || 0);
  return `${n.toLocaleString("fr-FR").replace(/\u202f/g, " ").replace(/,/g, " ")} FCFA`;
}

export function imageUrl(src, w) {
  if (!src) return "https://images.unsplash.com/photo-1445205170230-053b83016050?w=600&q=80";
  if (src.startsWith("/api")) return `${BACKEND_URL}${src}${w ? `?w=${w}` : ""}`;
  return src;
}

export function digitsOnly(phone) {
  return (phone || "").replace(/\D/g, "");
}

export function whatsappLink(number, text) {
  return `https://wa.me/${digitsOnly(number)}?text=${encodeURIComponent(text || "")}`;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "";
  const s = Math.floor((Date.now() - then) / 1000);
  if (s < 60) return "à l'instant";
  const m = Math.floor(s / 60);
  if (m < 60) return `il y a ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `il y a ${h} h`;
  const j = Math.floor(h / 24);
  return `il y a ${j} j`;
}

export const STATUS_LABELS = {
  en_attente_paiement: "En attente de paiement",
  paiement_confirme: "Paiement confirmé",
  en_preparation: "En préparation",
  expediee: "Expédiée",
  livree: "Livrée",
  annulee: "Annulée",
};

export const STATUS_COLORS = {
  en_attente_paiement: "bg-orange-100 text-orange-700 border-orange-200",
  paiement_confirme: "bg-blue-100 text-blue-700 border-blue-200",
  en_preparation: "bg-purple-100 text-purple-700 border-purple-200",
  expediee: "bg-sky-100 text-sky-700 border-sky-200",
  livree: "bg-green-100 text-green-700 border-green-200",
  annulee: "bg-red-100 text-red-700 border-red-200",
};

export const CLOTHING_TYPES = [
  { value: "robe", label: "Robe" },
  { value: "haut", label: "Haut" },
  { value: "bas", label: "Bas" },
  { value: "ensemble", label: "Ensemble" },
  { value: "accessoire", label: "Accessoire" },
];

export const SIZES = ["XS", "S", "M", "L", "XL", "XXL", "36", "38", "40", "42", "44", "46"];
